/**
 *
 */
export enum MyListingStatus {
  Active = 0,
  Inactive = 1,
  Draft = 2,
}
